import React, { useEffect, useState, useContext } from 'react'
import { useRouter } from 'next/router'
import NewsItems from './NewsItems'
import axios from 'axios'
import { style } from './NewsList.style'
import { CategoryContext } from './CategoryContext'

type OwnProps = {
  subcategory: 'event' | 'report'
}

const NewsList = (props: OwnProps) => {
  const category = useContext(CategoryContext)
  const { subcategory } = props
  const router = useRouter()
  const [news, setNews] = useState([])
  const [newsLength, setNewsLength] = useState(0)

  // 一覧表示
  const setContent = (item: any) => {
    return (
      <NewsItems
        key={item.id}
        id={item.id}
        img={item.acf.img}
        date={item.date}
        category={item.acf.category}
        subcategory={subcategory}
        title={item.title}
      />
    )
  }

  const getNews = async () => {
    const newEndPoint = `${process.env.NEXT_PUBLIC_API_BASE_URL}${process.env.NEXT_PUBLIC_NEWS}`

    await axios
      .get(newEndPoint, {
        params: {
          per_page: 6,
          page: 1,
          category: `${category},common`,
          subcategory,
        },
      })
      .then((res) => {
        setNews(res.data)
        setNewsLength(res.data.length)
      })
  }

  useEffect(() => {
    if (!router.isReady) return
    getNews()
  }, [])

  return newsLength > 0 ? (
    <div css={newsLength < 3 ? [style.cards, style.fewerCards] : style.cards}>
      {(() => {
        return news.map((contentObj) => setContent(contentObj))
      })()}
    </div>
  ) : (
    <p css={style.noData}>表示するデータがありません</p>
  )
}

export default NewsList
